import { Button, Tooltip } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';

type NotificationActionButtonsProps = {
  markNotificationAsRead: () => void;
};
const NotificationActionButtons: FC<NotificationActionButtonsProps> = (
  props
) => {
  const { markNotificationAsRead } = props;
  return (
    <div className="cursor-pointer sm:group-hover/listed-notification:opacity-100 sm:opacity-0 sm:absolute sm:top-5 sm:end-5 ">
      <div className="inline-block p-0.5 bg-white border border-gray-200 rounded-lg shadow-sm transition ease-out">
        <div className="flex items-center">
          <Tooltip
            tooltipContent="Mark this notification as read"
            className="@screen-lg:max-w-lg max-w-24 overflow-hidden text-ellipsis whitespace-nowrap text-left"
          >
            <Button
              onClick={(e) => {
                e.stopPropagation();
                markNotificationAsRead();
              }}
              variant="quaternary"
              size={'xs'}
              className="w-7 h-7 p-0 focus:shadow-none focus:ring-0"
            >
              <UntitledIcon name="check-square-broken.1" className="h-4 w-4" />
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default NotificationActionButtons;
